import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { setActiveSort } from "../../helpers/product";
import { Collapse } from "react-collapse";
import { Link } from "react-router-dom";

const ShopSize = ({ sizes, getSortParams }) => {
  //const [stateLista, setstateLista] = useState(global.aziendaID == 1? true : false);
  const [stateLista, setstateLista] = useState(false);
  const [sizeSelected, setSizeSelected] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.size
  );
  const [refresh, setRefresh] = useState(true);

  const CambioStato = () => {
    if (stateLista) setstateLista(false);
    else setstateLista(true);
  };
  useEffect(() => {
    setSizeSelected(JSON.parse(sessionStorage.getItem("filter"))?.size);
    setRefresh(!refresh);
  }, [sessionStorage.getItem("filter")]);
  return (
    <div className="sidebar-widget">
      <div
        data-role="title"
        role="tab"
        aria-selected="false"
        aria-expanded="false"
        tabindex="-1"
        onClick={() => CambioStato()}
        style={{
          fontSize: "17px",
          color: "black",
          fontWeight: 600,
          cursor: "pointer",
          lineHeight: "30px",
        }}
      >
        <span
          class={
            stateLista
              ? "icon pe-7s-angle-down pull-right"
              : "icon pe-7s-angle-up pull-right"
          }
          data-role="icons"
          style={{ display: "inline-block" }}
        >
          {" "}
        </span>
        Taglie
      </div>
      {/*<div className="shopping-cart-btn btn-hover text-center"  style={{padding:"10px"}}>
            <a style={{padding:"10px", border:"1px gray solid",display:"block", width:"100%"}}  onClick={() => CambioStato()}  >Taglie</a>
        </div>*/}
      {/* <h4  <h4 className="btn btn-primary btn-xs" onClick={() => CambioStato()}>Marchi </h4>*/}

      <Collapse
        theme={{ collapse: "foo", content: "bar" }}
        isOpened={stateLista}
      >
        <div className="sidebar-widget-tag">
          {sizes ? (
            <ul
              style={{
                display: "grid",
                placeItems: "center",
                gridTemplateColumns: "repeat(6, 1fr)",
              }}
            >
              <li style={{ gridColumn: "span 3" }}>
                <div className="sidebar-widget-list-left">
                  <button
                    id="allSizes"
                    onClick={(e) => {
                      document
                        .querySelectorAll(".sizes")
                        .forEach((element) =>
                          element.classList.remove("active")
                        );
                      if (e.currentTarget.classList.contains("active"))
                        getSortParams("size", "all", "-");
                      else getSortParams("size", "all", "+");
                      //getSortParams("size", "");
                      setActiveSort(e);
                    }}
                  >
                    <span className="checkmark" /> Tutte le taglie{" "}
                  </button>
                </div>
              </li>
              {sizes.map((size, key) => {
                if (size === "") return;
                return (
                  <li key={key}>
                    <div
                      className="sidebar-widget-list-left"
                      style={{ padding: "0px 0px 0px 0px" }}
                    >
                      <button
                        className={
                          "brands " +
                          (sizeSelected?.split("|").includes(size)
                            ? "active"
                            : "")
                        }
                        onClick={(e) => {
                          document
                            .querySelector("#allSizes")
                            .classList.remove("active");
                          if (e.currentTarget.classList.contains("active"))
                            getSortParams("size", size, "-");
                          else getSortParams("size", size, "+");
                          //getSortParams("size", size);
                          setActiveSort(e);
                        }}
                        style={{
                          fontSize: "smaller",
                          verticalAlign: "middle",
                          padding: "0px 5px 0px 0px",
                        }}
                      >
                        {" "}
                        <span className="checkmark" />
                        {size}{" "}
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
      </Collapse>
    </div>
  );
};

ShopSize.propTypes = {
  getSortParams: PropTypes.func,
  sizes: PropTypes.array,
};

export default ShopSize;
